import { render, staticRenderFns } from "./HeadlineContainer.vue?vue&type=template&id=3079ca65&"
import script from "./HeadlineContainer.vue?vue&type=script&lang=js&"
export * from "./HeadlineContainer.vue?vue&type=script&lang=js&"
import style0 from "./HeadlineContainer.vue?vue&type=style&index=0&id=3079ca65&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports